// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:02:38.665Z
// Property: The Crosby at the Brickyard Apartment Homes (ID: 5652651228266496)
// Collections: 38 amenities, 18 floorplans (live), 20 photos, 31 POIs, 4 reviews, 5 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "5652651228266496",
  "property_external_id": "1440849",
  "property_zillow_url": "https://www.zillow.com/apartments/farmers-branch-tx/the-crosby-at-the-brickyard-apartment-homes/ChcDTr/",
  "property_apartments_url": "https://www.apartments.com/the-crosby-at-the-brickyard-apartment-homes-farmers-branch-tx/6ex4vnv/",
  "property_google_business_url": "https://www.google.com/maps/place/Crosby+at+the+Brickyard/data=!4m2!3m1!1s0x0:0x9f4a1f41878c5ec2?sa=X&ved=2ahUKEwib09abhbmSAxWiBe8CHcunMoQQ_BJ6BAhAEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-crosby-at-the-brickyard-apartment-homes",
  "property_name": "The Crosby at the Brickyard Apartment Homes",
  "property_website_url": "https://www.crosbyatthebrickyard.com/",
  "property_domain": "https://www.crosbyatthebrickyard.com/",
  "property_address": "2001 Wittington Pl",
  "property_full_address": "2001 Wittington Pl, Farmers Branch, TX 75234",
  "property_address_1": "2001 Wittington Pl",
  "property_address_2": null,
  "property_address_city": "Farmers Branch",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "75234",
  "property_address_country": "US",
  "property_address_county": "Dallas County",
  "property_neighborhood_address": "Farmers Branch",
  "property_address_latitude": "32.9178924",
  "property_address_longitude": "-96.9111867",
  "property_email": "crosby@weidner.com",
  "property_phone": "9723825906",
  "property_call_tracking_phone": "469-291-0875",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your perfect home at The Crosby at the Brickyard in Farmers Branch, TX, featuring one and two-bedroom floor plans. Enjoy upscale amenities like open concept kitchens with granite countertops, a pet-friendly environment, and scenic walking trails. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "**Welcome to The Crosby at the Brickyard** – your idyllic retreat in Farmers Branch, TX! Discover our spacious one-bedroom and two-bedroom floor plans, thoughtfully designed to elevate your lifestyle. Each apartment offers upscale features, including open concept gourmet kitchens with granite countertops, energy-efficient stainless-steel GE appliances, and elegant designer tiles that make cooking a pleasure. Enjoy the charm of high ceilings ranging from 9 to 11 feet, paired with floor-to-ceiling windows that flood your living space with natural light.\n\nOur pet-friendly community is surrounded by tranquil green spaces, perfect for your furry friends to run and play. Get active with convenient access to a scenic walking and jogging trail along the water, or unwind at our grilling stations in inviting courtyards. Connectivity is easy with complimentary WiFi in communal areas and a robust Fiber Optic Spectrum internet package, ensuring you stay connected.\n\nAdditional amenities include parcel lockers for your convenience, valet trash service for hassle-free living, and security with our on-site courtesy patrol by Signal Security. Revel in the unique touches of one-of-a-kind art throughout the property and thoughtful design elements such as built-in bookshelves and mudroom storage.\n\nAt The Crosby at the Brickyard, modern comforts meet a vibrant community lifestyle. Find your new home today – browse our availability or schedule a tour to visit our welcoming community! We can’t wait to show you around!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-4551-73ad-90f9-b5777bb0857e.webp",
  "property_featured_image_media": {
    "alt_text": "Stylish living room with blue sofa, armchair, marble coffee table, and open-concept kitchen.",
    "public_id": "019d019e-4551-73ad-90f9-b5777bb0857e",
    "storage_key": "property/5652651228266496/019d019e-4551-73ad-90f9-b5777bb0857e.webp",
    "width": 3000,
    "height": 2000
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "232",
  "property_year_built": "2016",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.25862068965517",
  "property_admin_fee": null,
  "property_application_fee": "85",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://crosbyatthebrickyard.securecafe.com/onlineleasing/the-crosby-at-the-brickyard/floorplans.aspx",
  "property_resident_portal_url": "https://crosbyatthebrickyard.securecafenet.com/residentservices/the-crosby-at-the-brickyard/userlogin",
  "property_apply_now_url": "https://crosbyatthebrickyard.securecafe.com/onlineleasing/the-crosby-at-the-brickyard/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019f-3f00-771e-a354-7e4852808b09.webp",
  "property_primary_logo_media": {
    "alt_text": "The Crosby at The Brickyard logo",
    "public_id": "019d019f-3f00-771e-a354-7e4852808b09",
    "storage_key": "property/5652651228266496/019d019f-3f00-771e-a354-7e4852808b09.webp",
    "width": 122,
    "height": 75
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a1-5ead-769c-91f9-0fecff2f50db.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo with stylized buildings and text.",
    "public_id": "019d01a1-5ead-769c-91f9-0fecff2f50db",
    "storage_key": "property/5652651228266496/019d01a1-5ead-769c-91f9-0fecff2f50db.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a1-68c9-750b-9cfa-0e35f5f41165.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Crosby at The Brickyard logo",
    "public_id": "019d01a1-68c9-750b-9cfa-0e35f5f41165",
    "storage_key": "property/5652651228266496/019d01a1-68c9-750b-9cfa-0e35f5f41165.webp",
    "width": 122,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a1-73f2-70cf-b378-9f05d155325e.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Crosby at The Brickyard logo",
    "public_id": "019d01a1-73f2-70cf-b378-9f05d155325e",
    "storage_key": "property/5652651228266496/019d01a1-73f2-70cf-b378-9f05d155325e.webp",
    "width": 122,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#221e20",
  "property_secondary_color": "#8f7a48",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "650 - 1486",
  "property_sqft_min": "650",
  "property_sqft_max": "1486",
  "property_price_range": "1325.68 - 4700",
  "property_price_min": "1325.68",
  "property_price_max": "4700",
  "property_available_units": 29,
  "property_facebook_url": "https://www.facebook.com/TheCrosbyAtTheBrickyardApartments",
  "property_instagram_url": "https://www.instagram.com/thecrosbyatthebrickyardapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJE0o9s8QnTIYRwl6Mh0EfSp8",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Crosby at the Brickyard Apartment Homes",
  "property_home_romance_title": "Embrace Life in Your Charming New Apartment Community",
  "property_home_amenities_blurb": "Welcome to The Crosby at the Brickyard in Farmers Branch, TX, where modern living meets comfort. Choose from stylish one or two-bedroom floor plans featuring gourmet kitchens and expansive patios. Enjoy top-tier amenities like a fitness center, cabanas, and serene waterfront access—all designed to enhance your living experience.",
  "property_home_floorplans_blurb": "Nestled in the heart of Farmers Branch, TX, The Crosby at the Brickyard Apartment Homes offers thoughtfully designed one and two-bedroom floor plans. Each residence is a canvas for your unique lifestyle. Browse our available apartment homes today and uncover the ideal space that inspires your daily living experience.",
  "property_home_gallery_blurb": "At The Crosby at the Brickyard in Farmers Branch, TX, our beautifully designed one- and two-bedroom apartments blend luxury and comfort. Enjoy 24-hour access to amenities like a sparkling pool, fitness center, pet-friendly spaces, and community events. Picture yourself living here, where vibrant living meets seamless convenience.",
  "property_home_neighborhood_blurb": "Discover your perfect home at The Crosby at the Brickyard Apartment Homes in Farmers Branch, TX. Choose from spacious one-bedroom and two-bedroom floor plans designed for comfort. Explore our vibrant neighborhood, and see what's around our community—local favorites and nearby points of interest await your discovery!",
  "property_home_reviews_blurb": "Experience the unique charm of The Crosby at the Brickyard Apartment Homes in Farmers Branch, TX. With state-of-the-art appliances and stylish hardwood flooring, our community offers a quiet haven where friendly neighbors thrive. Join us for weekly events and see why residents are raving about their comfortable and inviting new home!",
  "property_neighborhood_blurb": "Nestled in the heart of Farmers Branch, The Crosby at the Brickyard offers exceptional living with access to vibrant local attractions. Enjoy esteemed educational institutions like Dallas College North Lake Campus and Parker University, or get your fitness fix at Luna Fitness Studio and Orangetheory Fitness. Experience community life at its best!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Discover elevated living at The Crosby at the Brickyard in Farmers Branch, TX. Our one and two-bedroom apartments feature open-concept gourmet kitchens, stunning granite countertops, and luxurious 9- to 11-foot ceilings. Enjoy pet-friendly green spaces, scenic walking trails, and exclusive community perks. Explore our amazing community amenities and apartment features today!",
  "property_applynow_blurb": "Discover your ideal living space at The Crosby at the Brickyard in Farmers Branch, TX. Choose from our stunning one and two-bedroom floor plans, featuring open-concept gourmet kitchens, luxurious granite countertops, and energy-efficient appliances. Enjoy exceptional amenities like walking trails, pet-friendly greens, and complimentary WiFi. Apply now and lease online today!",
  "property_contactus_blurb": "Discover your perfect home at The Crosby at the Brickyard Apartment Homes in Farmers Branch, TX. Explore our diverse floor plans, featuring spacious one and two-bedroom options designed for modern living. Have questions? Contact our leasing team today to learn more and schedule a tour!",
  "property_faqs_blurb": "Discover your ideal home at The Crosby at the Brickyard Apartment Homes in Farmers Branch, TX. Choose from spacious one and two-bedroom floor plans designed for your comfort. Have questions? Browse our FAQs page to get answers about our vibrant community and find the perfect fit for you!",
  "property_floorplans_blurb": "Discover your ideal living space at The Crosby at the Brickyard Apartment Homes in Farmers Branch, TX. With a variety of thoughtfully designed one and two-bedroom floor plans, there’s something for everyone. Browse our available apartment homes today and find the perfect floor plan to suit your lifestyle!",
  "property_gallery_blurb": "At The Crosby at the Brickyard in Farmers Branch, TX, our stunning one- and two-bedroom apartments feature open-concept gourmet kitchens with granite countertops and energy-efficient appliances. Enjoy our pet-friendly green spaces, scenic walking trails, and luxurious amenities. Picture yourself living here—explore our photo gallery today! ",
  "property_interactivemap_blurb": "Discover your ideal home at The Crosby at the Brickyard in Farmers Branch, TX. Choose from our stylish one and two-bedroom floor plans, featuring gourmet kitchens, energy-efficient appliances, and stunning views. Enjoy community amenities like walking trails, pet-friendly green spaces, and complimentary WiFi. Use our interactive map to explore available apartments today!",
  "property_pets_blurb": "Nestled in the heart of Farmers Branch, The Crosby at the Brickyard Apartment Homes offers a perfect blend of modern comfort and stylish living. Embrace tranquility in a vibrant community where your furry friends can thrive. Enjoy expansive green spaces, upscale amenities, and a lifestyle tailored just for you.",
  "property_referafriend_blurb": "Discover your ideal living space at The Crosby at the Brickyard Apartment Homes in Farmers Branch, TX! Choose from our stylish one-bedroom and spacious two-bedroom floor plans. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy all the fantastic amenities we have to offer!",
  "property_residentaccess_blurb": "Welcome to The Crosby at the Brickyard Apartment Homes in Farmers Branch, TX, where comfortable living meets modern convenience. Explore our spacious one and two-bedroom floor plans designed for your lifestyle. Access your resident portal today to pay rent, schedule maintenance, and enjoy a stress-free living experience!",
  "property_reviews_blurb": "At The Crosby at the Brickyard Apartment Homes, residents enjoy a uniquely stylish and serene environment. With state-of-the-art appliances and beautiful hardwood flooring, our townhomes truly impress. One satisfied resident raves, “The staff is really friendly, and my new neighbors are great!” Join our vibrant community in Farmers Branch, TX!",
  "property_created_at": "1752256405419",
  "property_scheduletour_blurb": "Discover your ideal home at The Crosby at the Brickyard Apartment Homes in Farmers Branch, TX. Choose from spacious one and two-bedroom floor plans designed for comfort and style. Schedule a tour today and see what our residents have to say about life in our vibrant community!",
  "property_thankyou_blurb": "Thank you for your interest in The Crosby at the Brickyard Apartment Homes in Farmers Branch, TX! Explore our spacious one and two-bedroom floor plans and discover your dream home. A member of our team will contact you shortly to assist with your inquiries. Live your best life at The Crosby!",
  "property_virtualtours_blurb": "Discover your perfect home at The Crosby at the Brickyard in Farmers Branch, TX! Explore our spacious one and two-bedroom floor plans designed for comfort and style. Don’t miss the opportunity to envision your future—take a virtual tour of our community and apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. The Crosby at the Brickyard Apartment Homes",
  "property_seo_title_home": "The Crosby at the Brickyard | Farmers Branch, TX",
  "property_seo_description_home": "Experience the convenience and comfort at The Crosby at the Brickyard in Farmers Branch, TX. We offer 1 and 2 bedroom apartments to fit your every need.",
  "property_seo_title_floorplans": "Floor Plans | The Crosby at the Brickyard | Farmers Branch, TX",
  "property_seo_description_floorplans": "The Crosby at the Brickyard, a pet-friendly community in Farmers Branch, TX, offers stylish one and two bedroom floor plans. View our layouts now!",
  "property_seo_title_amenities": "Amenities | The Crosby at the Brickyard | Farmers Branch, TX",
  "property_seo_description_amenities": "The Crosby at the Brickyard offers luxurious, vacation-inspired amenities so you can live life on vacation mode every day. Explore our amenities now!",
  "property_seo_title_gallery": "Photo Galley | The Crosby at the Brickyard Apartment Homes",
  "property_seo_description_gallery": "View high resolution photos and video tours of The Brickyard: The Crosby Apartments. Check out photos of model interiors and community features.",
  "property_seo_title_virtualtours": "Virtual Tour | The Crosby at the Brickyard Apartment Homes",
  "property_seo_description_virtualtours": "Visit The Crosby at the Brickyard in Farmers Branch, TX with a virtual or in-person tour. Discover apartments with designer finishes and community perks.",
  "property_seo_title_interactivemap": "Interactive Map | The Crosby at the Brickyard Apartment Homes Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at The Crosby at the Brickyard in Farmers Branch, TX! Explore our spacious one and two-bedroom floor plans, each designed with luxurious amenities like open-concept gourmet kitchens, energy-efficient stainless-steel appliances, and oversized patios. Enjoy pet-friendly green spaces, access to scenic walking and jogging trails, and complimentary WiFi in community areas. Our welcoming environment features grilling stations, valet trash service, and more! Use our interactive community map to find your perfect apartment today!",
  "property_seo_title_neighborhood": "Neighborhood | The Crosby at the Brickyard | Farmers Branch",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding The Crosby at the Brickyard in Farmers Branch, TX. Dining, entertainment, and schools are just steps away!",
  "property_seo_title_contact": "Contact Us | The Crosby at the Brickyard",
  "property_seo_description_contact": "Have questions? Contact us by phone, fill out the form, or drop by the leasing office for more information about our apartments in Farmers Branch, TX.",
  "property_seo_title_faqs": "FAQs | Apartments in Farmers Branch, TX",
  "property_seo_description_faqs": "Explore The Crosby at the Brickyard Apartment Homes in Farmers Branch, TX! Discover spacious one and two-bedroom floor plans designed with your comfort in mind, complete with gourmet kitchens, luxurious granite countertops, and designer finishes. Our pet-friendly community features scenic walking trails, grilling stations, and complimentary WiFi. Have questions? Browse our FAQs page to learn more about our unique amenities and lifestyle offerings!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Farmers Branch, TX",
  "property_seo_description_reviews": "Discover life at The Crosby at the Brickyard Apartment Homes in Farmers Branch, TX! Choose from spacious one and two-bedroom floor plans, and immerse yourself in our pet-friendly amenities, including serene walking trails, inviting grilling courtyards, and complimentary community WiFi. Experience luxurious living with features like granite countertops, energy-efficient GE appliances, and designer lighting. Check out what our residents love about their homes and see why The Crosby is the perfect community for you! ",
  "property_seo_title_applynow": "Apply Now | Apartments in Farmers Branch, TX",
  "property_seo_description_applynow": "Discover your ideal living space at The Crosby at the Brickyard Apartment Homes in Farmers Branch, TX! Choose from stylish one or two-bedroom floor plans featuring gourmet kitchens with granite countertops, energy-efficient appliances, and design elements such as built-in coffee bars and oversized patios. Enjoy exceptional amenities like a walking trail along the water, pet-friendly green spaces, complimentary WiFi, and convenient parcel lockers. With a focus on comfort and security, our community offers valet trash service and courtesy security patrols. Ready to elevate your lifestyle? Apply now and find your new home today!",
  "property_seo_title_residentaccess": "Resident Access | The Crosby at the Brickyard Apartment Homes",
  "property_seo_description_residentaccess": "\"Login to The Crosby at the Brickyard's resident portal for Farmers Branch, TX! Easily pay rent, schedule maintenance, and access essential resources that enhance your living experience. Get started today!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Crosby at the Brickyard Apartment Homes",
  "property_seo_description_referafriend": "\"Discover the joy of community living at The Crosby at the Brickyard in Farmers Branch, TX! Refer a friend today and enjoy the perks of great neighbors in our vibrant apartment homes. Spread the word and enhance your living experience!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Farmers Branch, TX",
  "property_seo_description_scheduletour": "See The Crosby at the Brickyard in person or virtually! Schedule your tour today and explore our 1 and 2 bedroom apartment homes in Farmers Branch, TX.",
  "property_seo_title_privacy": "Privacy Policy | The Crosby at the Brickyard",
  "property_seo_description_privacy": "Your privacy is important to us. Read The Crosby at the Brickyard’s privacy policy to learn how we protect your information.",
  "property_seo_title_accessibility": "Accessibility | Farmers Branch, TX",
  "property_seo_description_accessibility": "Learn how The Crosby at the Brickyard website is built to be accessible and user-friendly for everyone in Farmers Branch, TX.",
  "property_seo_title_sitemap": "Sitemap | The Crosby at the Brickyard Apartment Homes",
  "property_seo_description_sitemap": "Discover everything you need to know about The Crosby at the Brickyard Apartment Homes in Farmers Branch, TX!",
  "property_seo_title_thankyou": "Thank You | The Crosby at the Brickyard | Farmers Branch, TX",
  "property_seo_description_thankyou": "Thank you for contacting the leasing team at The Crosby at the Brickyard. We’ll be in touch soon to help you find your perfect home!",
  "property_seo_title_pets": "Pet Policy | The Crosby at the Brickyard | Farmers Branch, TX",
  "property_seo_description_pets": "The Crosby at the Brickyard offers top-tier pet-friendly living in Farmers Branch, TX. View our pet policy and bring your furry friend home!",
  "property_updated_at": "1791293566156",
  "amenities": [
    {
      "id": "ec_14ef35c9d43c313356a48edf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427661",
      "title": "Resort pool with cabanas and loungers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d99d7-55de-72a8-b1e9-455baf0d4462.webp",
      "amenity_image_media": {
        "alt_text": "Luxury apartment building with a pool and lounge chairs.",
        "public_id": "019d99d7-55de-72a8-b1e9-455baf0d4462",
        "storage_key": "property/5652651228266496/019d99d7-55de-72a8-b1e9-455baf0d4462.webp",
        "width": 823,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_254fbdf204c29c3d90571ce7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427666",
      "title": "The Parlor clubroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d99d7-55d8-767a-9538-e17fe466f5f8.webp",
      "amenity_image_media": {
        "alt_text": "Elegant lounge area with a grand piano, bar, and seating.",
        "public_id": "019d99d7-55d8-767a-9538-e17fe466f5f8",
        "storage_key": "property/5652651228266496/019d99d7-55d8-767a-9538-e17fe466f5f8.webp",
        "width": 810,
        "height": 526
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91d1c1cec5e01e9c1c8591ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427682",
      "title": "24-Hour fitness center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d99d7-55dc-7647-9439-31f5f915bb6c.webp",
      "amenity_image_media": {
        "alt_text": "Gym with cardio and weight machines",
        "public_id": "019d99d7-55dc-7647-9439-31f5f915bb6c",
        "storage_key": "property/5652651228266496/019d99d7-55dc-7647-9439-31f5f915bb6c.webp",
        "width": 788,
        "height": 686
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8a89793871ce164abac38f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427687",
      "title": "Serene courtyard with Spanish fountain and fire table",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d99d7-55df-775a-9cd5-9051a61c5b9a.webp",
      "amenity_image_media": {
        "alt_text": "Courtyard with a fountain, seating areas, and surrounding apartment buildings.",
        "public_id": "019d99d7-55df-775a-9cd5-9051a61c5b9a",
        "storage_key": "property/5652651228266496/019d99d7-55df-775a-9cd5-9051a61c5b9a.webp",
        "width": 811,
        "height": 691
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_463da66c6eca2269c30dfd6d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427690",
      "title": "Access controlled building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8932524525fee1fba246e449",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427694",
      "title": "Elevator access & covered parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6adc188441b2c18b45b7dd01",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427699",
      "title": "Access to walking & jogging trail along the water",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019f-162a-73ea-9edd-0ea18b55878f.webp",
      "amenity_image_media": {
        "alt_text": "Two Adirondack chairs facing a serene pond surrounded by lush trees under a bright blue sky with fluffy clouds.",
        "public_id": "019d019f-162a-73ea-9edd-0ea18b55878f",
        "storage_key": "property/5652651228266496/019d019f-162a-73ea-9edd-0ea18b55878f.webp",
        "width": 809,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d87aaa45a5cda23731f2820",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427696",
      "title": "Pet-friendly green spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019f-30ff-7563-9a39-281ccfb8146a.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of a modern apartment building with manicured lawns and a curved driveway.",
        "public_id": "019d019f-30ff-7563-9a39-281ccfb8146a",
        "storage_key": "property/5652651228266496/019d019f-30ff-7563-9a39-281ccfb8146a.webp",
        "width": 3072,
        "height": 1728
      },
      "amenity_image_alt_text": "a row of apartment buildings with green grass and a sidewalk",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ade8ed7745752c4ecf1d376",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427698",
      "title": "Complimentary WiFi in community spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c08b4e0589ddf5f604dd49bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427705",
      "title": "Grilling stations in courtyards",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019f-1ba5-7520-b4b3-6c9448b1718e.webp",
      "amenity_image_media": {
        "alt_text": "Modern apartment building with a courtyard pool and outdoor grill.",
        "public_id": "019d019f-1ba5-7520-b4b3-6c9448b1718e",
        "storage_key": "property/5652651228266496/019d019f-1ba5-7520-b4b3-6c9448b1718e.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "a patio with a grill and a pool in front of an apartment building",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2180f2aa59e613f82d17d24",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427707",
      "title": "Parcel lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4847cff9209301b271b2a5fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427710",
      "title": "One-of-a-kind art",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2da7b5f2228228bc4963256",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "120915004",
      "title": "Valet Trash",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9ed995d48ff5a122e7665a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "121699055",
      "title": "Courtesy Security Patrol by Signal Security",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_165bb7136aefe9cd542799dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "124799897",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c8c1bc6f61e88a9deea87e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427727",
      "title": "Wood-style plank flooring throughout*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa8ed295690ef48ff2619d4e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427728",
      "title": "Walk-in closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3522f5cc2b167bd3f3ed09f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427737",
      "title": "Ceiling fans in bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69de6cdcd0ddbee5d98dd661",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427739",
      "title": "Plush carpet in bedrooms*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0aaec690ec153e96e7f65d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427740",
      "title": "Washer & dryer connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ee0196bc87a27df28dae317",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427742",
      "title": "Full size stackable washer & dryer included*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c62f4c5ec6edbe3cb8598739",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427731",
      "title": "Kitchen islands*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019f-161e-7258-96c7-a267153d0ec0.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite island, stainless steel appliances, and pendant lights.",
        "public_id": "019d019f-161e-7258-96c7-a267153d0ec0",
        "storage_key": "property/5652651228266496/019d019f-161e-7258-96c7-a267153d0ec0.webp",
        "width": 801,
        "height": 691
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6139911dca1cb82d12371d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427724",
      "title": "Open concept gourmet kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d364d08658cbf66ff4137b88",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427725",
      "title": "Granite countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8fef020e2d9ae94b3f323cd7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427726",
      "title": "Choice of designer custom cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22a10a29de11903883a5c438",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427729",
      "title": "Energy efficient stainless-steel GE appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5ba5b4a07cfa5b9d6b0b1d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427730",
      "title": "Designer tile backsplash",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c7907fd25c38590c42a729bd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427732",
      "title": "Built-in coffee bar*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_feff79801e1c6b968e3e8c96",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427734",
      "title": "Stainless steel sinks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36fb53548c419ba4870af739",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427735",
      "title": "Designer pendant lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6868630026e200e1d71b79f7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427736",
      "title": "9- to 11-foot ceilings throughout",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3bc5e4deb7eca295742f29f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427738",
      "title": "Fiber Optic Spectrum internet package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d8d4958f78b318b34afe9c25",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427743",
      "title": "Balcony/Patio*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_03841af002d87f087b17daa7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427744",
      "title": "Built-in bookshelves*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b830a153821c47edc4109d17",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "89427745",
      "title": "Entryway mudrooms with storage cubbies*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_126b2e521d6b70d01bf0cbc3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "90171105",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c26c173e7b681166680d801e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "90171107",
      "title": "Oversized Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac94f9075805d3fb6e912dd1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "yardi",
      "external_id": "90171112",
      "title": "Floor to Ceiling Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_e7c79384db580f996db24bc8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-4551-73ad-90f9-b5777bb0857e.webp",
      "image_media": {
        "alt_text": "Stylish living room with blue sofa, armchair, marble coffee table, and open-concept kitchen.",
        "public_id": "019d019e-4551-73ad-90f9-b5777bb0857e",
        "storage_key": "property/5652651228266496/019d019e-4551-73ad-90f9-b5777bb0857e.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Experience modern living in this beautifully appointed apartment, featuring a vibrant living space and a sleek, open-concept kitchen perfect for entertaining.",
      "link": "false",
      "alt_text": "Stylish living room with blue sofa, armchair, marble coffee table, and open-concept kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (1).jpg"
    },
    {
      "id": "ec_416ca59f076be509e526381c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-3bff-77bb-90f4-88d96677fc1c.webp",
      "image_media": {
        "alt_text": "Get up to $2000 off select units and $1000 off pre-leased on select homes with Equal Housing Opportunity logo.",
        "public_id": "019d019e-3bff-77bb-90f4-88d96677fc1c",
        "storage_key": "property/5652651228266496/019d019e-3bff-77bb-90f4-88d96677fc1c.webp",
        "width": 1084,
        "height": 684
      },
      "title": "Other",
      "description": "Limited-time offer: Get up to $2000 off select units and $1000 off pre-leased on select homes. Restrictions and terms apply. Contact leasing office for details. Includes Equal Housing Opportunity logo.",
      "link": "false",
      "alt_text": "Get up to $2000 off select units and $1000 off pre-leased on select homes with Equal Housing Opportunity logo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Specials (2342).png"
    },
    {
      "id": "ec_2f7bdba515479efd9bb98d88",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-40f0-77c2-b5d1-5365640bb28a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island with bar stools.",
        "public_id": "019d019e-40f0-77c2-b5d1-5365640bb28a",
        "storage_key": "property/5652651228266496/019d019e-40f0-77c2-b5d1-5365640bb28a.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Discover this beautifully designed kitchen featuring stainless steel appliances, sleek cabinetry, and a spacious granite island perfect for casual dining or entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (2).jpg"
    },
    {
      "id": "ec_48de3e17d19dafef0b08a62a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-46c1-7151-9cd0-83681048a615.webp",
      "image_media": {
        "alt_text": "Modern living room with blue sofa, armchair, and mural wallpaper.",
        "public_id": "019d019e-46c1-7151-9cd0-83681048a615",
        "storage_key": "property/5652651228266496/019d019e-46c1-7151-9cd0-83681048a615.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a plush blue sofa, chic armchair, and an eye-catching mural wallpaper. Perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Modern living room with blue sofa, armchair, and mural wallpaper.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (3).jpg"
    },
    {
      "id": "ec_7c3e8f51cdfe58e47d3e833a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-5a55-7755-88f5-2aacba2a10a3.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a king-sized bed, plush bedding, and stylish decor.",
        "public_id": "019d019e-5a55-7755-88f5-2aacba2a10a3",
        "storage_key": "property/5652651228266496/019d019e-5a55-7755-88f5-2aacba2a10a3.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this beautifully appointed bedroom, featuring a king-sized bed, elegant green headboard, and modern light fixtures.",
      "link": "false",
      "alt_text": "Luxurious bedroom with a king-sized bed, plush bedding, and stylish decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (4).jpg"
    },
    {
      "id": "ec_eb0d0aace0f9ab2ddf502c2c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-5b93-7009-bb2f-943cc843812d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertops, a walk-in closet, and shower.",
        "public_id": "019d019e-5b93-7009-bb2f-943cc843812d",
        "storage_key": "property/5652651228266496/019d019e-5b93-7009-bb2f-943cc843812d.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of a spacious bathroom with ample storage and a sleek design, complete with a walk-in closet.",
      "link": "false",
      "alt_text": "Modern bathroom with granite countertops, a walk-in closet, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (5).jpg"
    },
    {
      "id": "ec_bfa8f3b8d0617c21f460cdc4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-5c09-714d-aefc-ffbaef972d7f.webp",
      "image_media": {
        "alt_text": "Washer and dryer set in a laundry room.",
        "public_id": "019d019e-5c09-714d-aefc-ffbaef972d7f",
        "storage_key": "property/5652651228266496/019d019e-5c09-714d-aefc-ffbaef972d7f.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry days. Includes overhead shelving for storage.",
      "link": "false",
      "alt_text": "Washer and dryer set in a laundry room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (6).jpg"
    },
    {
      "id": "ec_ec7e5ca942bec36140ead75f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-694e-706b-a19b-5ece86228efe.webp",
      "image_media": {
        "alt_text": "Kitchen with island and open living space",
        "public_id": "019d019e-694e-706b-a19b-5ece86228efe",
        "storage_key": "property/5652651228266496/019d019e-694e-706b-a19b-5ece86228efe.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring granite countertops, a large island, and stainless steel appliances, flowing into an open-concept living area with abundant natural light.",
      "link": "false",
      "alt_text": "Kitchen with island and open living space",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (7).jpg"
    },
    {
      "id": "ec_4936cd1affeeb29c21afcd46",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-74c7-7127-b772-7325bb6d5538.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with dark wood floors, white walls, and a ceiling fan.",
        "public_id": "019d019e-74c7-7127-b772-7325bb6d5538",
        "storage_key": "property/5652651228266496/019d019e-74c7-7127-b772-7325bb6d5538.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious and bright apartment living area, featuring hardwood floors, a modern ceiling fan, and large windows that let in ample natural light.",
      "link": "false",
      "alt_text": "Empty apartment living room with dark wood floors, white walls, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (8).jpg"
    },
    {
      "id": "ec_f7e9e540c65ced8f55919f52",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-6fe5-740e-9a96-8828f479da94.webp",
      "image_media": {
        "alt_text": "Living room with door leading to bedroom, featuring wood floors, white walls, ceiling fan, and large windows.",
        "public_id": "019d019e-6fe5-740e-9a96-8828f479da94",
        "storage_key": "property/5652651228266496/019d019e-6fe5-740e-9a96-8828f479da94.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Spacious living area with modern finishes, including wood plank flooring, a ceiling fan, and ample natural light from large windows. An adjoining room offers additional living space.",
      "link": "false",
      "alt_text": "Living room with door leading to bedroom, featuring wood floors, white walls, ceiling fan, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (9).jpg"
    },
    {
      "id": "ec_d27f325e879cbb94272c2831",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-74c7-7127-b772-74be50034901.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines and weightlifting equipment",
        "public_id": "019d019e-74c7-7127-b772-74be50034901",
        "storage_key": "property/5652651228266496/019d019e-74c7-7127-b772-74be50034901.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring treadmills, ellipticals, weight machines, and free weights for residents to enjoy.",
      "link": "false",
      "alt_text": "Gym with cardio machines and weightlifting equipment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (10).jpg"
    },
    {
      "id": "ec_954fa6a9ac762293e604a785",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-90f4-76eb-be8c-4df68583a3da.webp",
      "image_media": {
        "alt_text": "Bar area with a grand piano and seating",
        "public_id": "019d019e-90f4-76eb-be8c-4df68583a3da",
        "storage_key": "property/5652651228266496/019d019e-90f4-76eb-be8c-4df68583a3da.webp",
        "width": 3072,
        "height": 1729
      },
      "title": "Community",
      "description": "Stylish bar area with a grand piano, comfortable seating, and decorative artwork. A perfect space for socializing and relaxation.",
      "link": "false",
      "alt_text": "Bar area with a grand piano and seating",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (11).jpg"
    },
    {
      "id": "ec_8ecb0e852a1ef3caa31ee668",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-85b4-7487-bd27-8d43a6f1daa7.webp",
      "image_media": {
        "alt_text": "Living room with tufted sofa, modern coffee table, and decorative chairs.",
        "public_id": "019d019e-85b4-7487-bd27-8d43a6f1daa7",
        "storage_key": "property/5652651228266496/019d019e-85b4-7487-bd27-8d43a6f1daa7.webp",
        "width": 800,
        "height": 450
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a dark tufted sofa, geometric coffee table, and accent chairs with a large window for natural light.",
      "link": "false",
      "alt_text": "Living room with tufted sofa, modern coffee table, and decorative chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (12).jpg"
    },
    {
      "id": "ec_7bd7e61dd75d559457eaee09",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-9ae8-774b-bfe1-d87de136f260.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex with a swimming pool and cabana.",
        "public_id": "019d019e-9ae8-774b-bfe1-d87de136f260",
        "storage_key": "property/5652651228266496/019d019e-9ae8-774b-bfe1-d87de136f260.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool at this upscale apartment community. Enjoy the cabana and sun loungers.",
      "link": "false",
      "alt_text": "Luxury apartment complex with a swimming pool and cabana.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (13).jpg"
    },
    {
      "id": "ec_e9e0cc7ed66d7fad3b18e84f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-9858-7374-903d-e282729f258f.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas surrounded by modern apartment buildings.",
        "public_id": "019d019e-9858-7374-903d-e282729f258f",
        "storage_key": "property/5652651228266496/019d019e-9858-7374-903d-e282729f258f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge chairs and shaded umbrellas. The perfect place to relax and unwind.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas surrounded by modern apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (14).JPG"
    },
    {
      "id": "ec_008964464613ce59a6985488",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-963a-703c-9204-d531fe7287f5.webp",
      "image_media": {
        "alt_text": "Courtyard with fountain, seating, and gas fire pit.",
        "public_id": "019d019e-963a-703c-9204-d531fe7287f5",
        "storage_key": "property/5652651228266496/019d019e-963a-703c-9204-d531fe7287f5.webp",
        "width": 800,
        "height": 533
      },
      "title": "Community",
      "description": "Relax and unwind in our serene courtyard featuring a beautiful fountain, comfortable seating areas, and a modern gas fire pit for evening ambiance.",
      "link": "false",
      "alt_text": "Courtyard with fountain, seating, and gas fire pit.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (15).jpg"
    },
    {
      "id": "ec_38cad7d2ab34a7b2aab91e43",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-ad71-75ae-9965-f22e0178f23c.webp",
      "image_media": {
        "alt_text": "Courtyard with fountain, seating, and trees.",
        "public_id": "019d019e-ad71-75ae-9965-f22e0178f23c",
        "storage_key": "property/5652651228266496/019d019e-ad71-75ae-9965-f22e0178f23c.webp",
        "width": 3072,
        "height": 1729
      },
      "title": "Community",
      "description": "Enjoy the serene courtyard, complete with a beautiful fountain and comfortable seating areas. Perfect for relaxing or socializing.",
      "link": "false",
      "alt_text": "Courtyard with fountain, seating, and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (16).jpg"
    },
    {
      "id": "ec_8f700dc1936011c1da7d888f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-a244-7368-9a9a-7530365431a6.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with balconies and manicured landscaping.",
        "public_id": "019d019e-a244-7368-9a9a-7530365431a6",
        "storage_key": "property/5652651228266496/019d019e-a244-7368-9a9a-7530365431a6.webp",
        "width": 800,
        "height": 533
      },
      "title": "Community",
      "description": "View of the elegant exterior of our apartment building, showcasing its beautiful architecture and lush surroundings.",
      "link": "false",
      "alt_text": "Exterior of a modern apartment building with balconies and manicured landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (17).jpg"
    },
    {
      "id": "ec_f92e2657831fa3d44cd99287",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-a68c-70a9-96bb-88ecdd7ce8c5.webp",
      "image_media": {
        "alt_text": "Exterior view of a luxury apartment building with a manicured lawn and parking area.",
        "public_id": "019d019e-a68c-70a9-96bb-88ecdd7ce8c5",
        "storage_key": "property/5652651228266496/019d019e-a68c-70a9-96bb-88ecdd7ce8c5.webp",
        "width": 800,
        "height": 533
      },
      "title": "Community",
      "description": "Discover elegant apartment living with this stunning exterior view, showcasing lush landscaping and modern architecture.",
      "link": "false",
      "alt_text": "Exterior view of a luxury apartment building with a manicured lawn and parking area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (18).jpg"
    },
    {
      "id": "ec_6c198ae2b4ff49328d878665",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d019e-ab5b-76fc-a0ff-47b518f5b984.webp",
      "image_media": {
        "alt_text": "Exterior of The Brickyard Apartments & Townhomes building with \"The Crosby\" signage.",
        "public_id": "019d019e-ab5b-76fc-a0ff-47b518f5b984",
        "storage_key": "property/5652651228266496/019d019e-ab5b-76fc-a0ff-47b518f5b984.webp",
        "width": 800,
        "height": 533
      },
      "title": "Community",
      "description": "Beautiful exterior view of The Brickyard Apartments & Townhomes, featuring \"The Crosby\" signage and elegant architecture under a vibrant sky.",
      "link": "false",
      "alt_text": "Exterior of The Brickyard Apartments & Townhomes building with \"The Crosby\" signage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Crosby_at_the_Brickyard_Favorites (19).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e7e4b719-a7d0-4b1c-8a8e-1d22ea7ce719",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Roots Southern Table",
      "poi_type": "Restaurants",
      "poi_address": "13050 Bee St, Farmers Branch, TX 75234",
      "poi_short_description": "",
      "poi_long_description": "Roots Southern Table introduces Chef Tiffany Derry's creative culinary interpretation of Southern food. It is the celebration of food and who we are - our roots! The founders, Chef Tiffany and Tom Foley know that we are stronger together and that we must honor our roots. At Roots Southern Table, Tiffany, Tom, and the team evoke the feeling that you’re coming home.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-6629-7727-9510-52677c5b3c1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-6629-7727-9510-52677c5b3c1c",
        "storage_key": "property/5652651228266496/019d01a0-6629-7727-9510-52677c5b3c1c.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/roots-southern-table-farmers-branch-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.92282298496031,-96.89549413976818",
      "poi_item_slug": "roots-southern-table-farmers-branch-2",
      "poi_latitude": "32.92282298496031",
      "poi_longitude": "-96.89549413976818",
      "poi_miles_from_property": "1.02",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+12143464441",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJaRaBhbcnTIYRWorlkgfpBGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bfcfb3b8-8e06-45ba-b4a8-6ca3a4c580a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "No.1 Plus Chicken",
      "poi_type": "Restaurants",
      "poi_address": "2240 Royal Ln, Ste 103, Dallas, TX 75229",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-6627-74d9-81e7-0901fa464411.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-6627-74d9-81e7-0901fa464411",
        "storage_key": "property/5652651228266496/019d01a0-6627-74d9-81e7-0901fa464411.webp",
        "width": 1000,
        "height": 630
      },
      "poi_business_url": "https://www.yelp.com/biz/no-1-plus-chicken-dallas?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.89441745402634,-96.90322316100652",
      "poi_item_slug": "no-1-plus-chicken-dallas",
      "poi_latitude": "32.89441745402634",
      "poi_longitude": "-96.90322316100652",
      "poi_miles_from_property": "1.67",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+19724889100",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJBasXjPMnTIYRr86txSdnGRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_94379ff5-2433-472d-aa1e-053b3a1d866c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Doma Seolleongtang",
      "poi_type": "Restaurants",
      "poi_address": "11441 N Stemmons Fwy, Ste 137, Dallas, TX 75229",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-6593-77c0-bccd-dc7a495c7c5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-6593-77c0-bccd-dc7a495c7c5f",
        "storage_key": "property/5652651228266496/019d01a0-6593-77c0-bccd-dc7a495c7c5f.webp",
        "width": 1000,
        "height": 621
      },
      "poi_business_url": "https://www.yelp.com/biz/doma-seolleongtang-dallas-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.89892,-96.89892",
      "poi_item_slug": "doma-seolleongtang-dallas-2",
      "poi_latitude": "32.89892",
      "poi_longitude": "-96.89892",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+14693725204",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJf7vaYrcnTIYRJS0KsQOTPJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f9165407-d943-44a7-884d-46518fda4197",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "JOA Grill",
      "poi_type": "Restaurants",
      "poi_address": "2254 Royal Ln, Dallas, TX 75229",
      "poi_short_description": "",
      "poi_long_description": "JOA GRILL is a vibrant Korean barbecue restaurant where authentic techqniue meets modern flavors burst forth from the depths of its sizzling grills in Dallas. Their website can be found on joagrill.com, where you can catch a glimpse of the flavorful dishes and learn more about the restaurant's unique offerings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-658e-71fe-892c-068ac536e27d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-658e-71fe-892c-068ac536e27d",
        "storage_key": "property/5652651228266496/019d01a0-658e-71fe-892c-068ac536e27d.webp",
        "width": 268,
        "height": 341
      },
      "poi_business_url": "https://www.yelp.com/biz/joa-grill-dallas-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.895041,-96.90246",
      "poi_item_slug": "joa-grill-dallas-2",
      "poi_latitude": "32.895041",
      "poi_longitude": "-96.90246",
      "poi_miles_from_property": "1.65",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+19722413900",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJG0LXPUAnTIYRzSnOzNCiPEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_517e3313-a123-4e9f-8df8-7289339cedb4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Bugatti Ristorante",
      "poi_type": "Restaurants",
      "poi_address": "1940 Lbj Fwy, Farmers Branch, TX 75234",
      "poi_short_description": "",
      "poi_long_description": "Bugatti’s is recognized for offering a menu of authentic Northern Italian cuisine and light fare offerings created with in-home-crafted recipes. However, the hallmark of Bugatti’s has always been the unparalleled guest experience, inspired by owner, Zee Bugatti. His philosophy of “First Class Dining on a First Name Basis” perfectly captures the Bugatti dining experience. Every guest, even on their first visit, is made to feel like a long-time, regular customer. The restaurant is renowned for catering some of the region’s most important special events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-6a2d-776a-a44d-6a128d5b1e5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-6a2d-776a-a44d-6a128d5b1e5d",
        "storage_key": "property/5652651228266496/019d01a0-6a2d-776a-a44d-6a128d5b1e5d.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.yelp.com/biz/bugatti-ristorante-farmers-branch?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.90570036684595,-96.91405193771678",
      "poi_item_slug": "bugatti-ristorante-farmers-branch",
      "poi_latitude": "32.90570036684595",
      "poi_longitude": "-96.91405193771678",
      "poi_miles_from_property": "0.82",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+12143502470",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJEXpyRAAnTIYR0_JXXQPRx-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ae67862a-d0b7-4026-94fa-8a801bfe56a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Dallas College Brookhaven Campus",
      "poi_type": "Universities",
      "poi_address": "3939 Valley View Ln, Dallas, TX 75244",
      "poi_short_description": "",
      "poi_long_description": "Founded in 1978, Brookhaven is one of the seven main campuses of Dallas College. Brookhaven is a diverse, progressive educational environment enriching the lives of students, employees and community members. We provide affordable options in higher education, ranging from transferable freshman- and sophomore-level classes and degrees and stand-alone associate degrees, skills awards and certificates, at about one-quarter of the cost of a university.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-6a01-72ba-98c1-b8f4d498bcb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-6a01-72ba-98c1-b8f4d498bcb7",
        "storage_key": "property/5652651228266496/019d01a0-6a01-72ba-98c1-b8f4d498bcb7.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/dallas-college-brookhaven-campus-dallas?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.9283355,-96.8504275",
      "poi_item_slug": "dallas-college-brookhaven-campus-dallas",
      "poi_latitude": "32.9283355",
      "poi_longitude": "-96.8504275",
      "poi_miles_from_property": "3.64",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+19728604700",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJb8_qFCQnTIYRDPKPtJBh5AI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3217d8d8-face-4594-abd6-722b00b03862",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Texas Laser Institute",
      "poi_type": "Universities",
      "poi_address": "4201 Wingren Dr, Ste 202, Irving, TX 75062",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-6a28-7029-a1fb-1f88c979604e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-6a28-7029-a1fb-1f88c979604e",
        "storage_key": "property/5652651228266496/019d01a0-6a28-7029-a1fb-1f88c979604e.webp",
        "width": 751,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/texas-laser-institute-irving?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.86133360486771,-96.9422309153427",
      "poi_item_slug": "texas-laser-institute-irving",
      "poi_latitude": "32.86133360486771",
      "poi_longitude": "-96.9422309153427",
      "poi_miles_from_property": "4.26",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+19727197102",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJcztJ1MGCToYRC9bpB0bw9Ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_afae410e-a41a-4713-b677-16f7b60b5b81",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "University Of Dallas",
      "poi_type": "Universities",
      "poi_address": "1845 E Northgate Dr, Irving, TX 75062",
      "poi_short_description": "",
      "poi_long_description": "The Catholic University for Independent Thinkers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-6aa8-7359-8638-3ae2e3407a5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-6aa8-7359-8638-3ae2e3407a5d",
        "storage_key": "property/5652651228266496/019d01a0-6aa8-7359-8638-3ae2e3407a5d.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/university-of-dallas-irving-4?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.846211,-96.921039",
      "poi_item_slug": "university-of-dallas-irving-4",
      "poi_latitude": "32.846211",
      "poi_longitude": "-96.921039",
      "poi_miles_from_property": "4.95",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+19727214108",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d5e08fee-d8a7-46e0-9b94-aa6e85043137",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Parker University",
      "poi_type": "Universities",
      "poi_address": "2540 Walnut Hill Ln, Dallas, TX 75229",
      "poi_short_description": "",
      "poi_long_description": "Parker University equips its graduates in health sciences, technology, business, and education communities to establish trends in health and wellness through its certificate, associates, bachelors, masters, and doctoral degrees",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-6e32-71d8-877c-09756d15590d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-6e32-71d8-877c-09756d15590d",
        "storage_key": "property/5652651228266496/019d01a0-6e32-71d8-877c-09756d15590d.webp",
        "width": 800,
        "height": 560
      },
      "poi_business_url": "https://www.yelp.com/biz/parker-university-dallas?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.880149,-96.892803",
      "poi_item_slug": "parker-university-dallas",
      "poi_latitude": "32.880149",
      "poi_longitude": "-96.892803",
      "poi_miles_from_property": "2.81",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+18004386932",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJq0AxyGWdToYRhF0F6HOu1aU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4e6b0226-0e8a-4299-9f87-f211038bbee3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Dallas College North Lake Campus",
      "poi_type": "Universities",
      "poi_address": "5001 N MacArthur Blvd, Irving, TX 75038",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-6d9e-7558-ad15-2239651b4af7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-6d9e-7558-ad15-2239651b4af7",
        "storage_key": "property/5652651228266496/019d01a0-6d9e-7558-ad15-2239651b4af7.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/dallas-college-north-lake-campus-irving?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.870862,-96.966744",
      "poi_item_slug": "dallas-college-north-lake-campus-irving",
      "poi_latitude": "32.870862",
      "poi_longitude": "-96.966744",
      "poi_miles_from_property": "4.53",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+19722733000",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ4x2g3WKCToYRPy6VvqlDgyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f8cad7a1-ed41-4088-b240-ecb9ea51a746",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Luna Fitness Studio",
      "poi_type": "Gyms",
      "poi_address": "11488 Luna Rd, Dallas, TX 75234",
      "poi_short_description": "",
      "poi_long_description": "Personal Training Studio. Small Group Fitness Studio. Nutrition Coaching.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-6dc1-7387-add2-4dc1c26b20a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-6dc1-7387-add2-4dc1c26b20a1",
        "storage_key": "property/5652651228266496/019d01a0-6dc1-7387-add2-4dc1c26b20a1.webp",
        "width": 1000,
        "height": 771
      },
      "poi_business_url": "https://www.yelp.com/biz/luna-fitness-studio-dallas?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.89849497399862,-96.9178834873505",
      "poi_item_slug": "luna-fitness-studio-dallas",
      "poi_latitude": "32.89849497399862",
      "poi_longitude": "-96.9178834873505",
      "poi_miles_from_property": "1.36",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+12145449255",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJWwc10fwnTIYR_3s6JVoqTfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_01847f3f-d56c-44c4-ba60-b560c99e6b1d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Strong Fitness, Performance & Ninja Dallas",
      "poi_type": "Gyms",
      "poi_address": "4207 Simonton Rd, Farmers Branch, TX 75244",
      "poi_short_description": "",
      "poi_long_description": "Strong Fitness, Performance, and Ninja is a premier climate-controlled fitness park in Dallas, Texas that has been serving customers for over 15 years. We are the go-to venue for corporate team building, school events, birthday parties, fitness and performance training programs for all ages and skill levels, as well as a unique variety of ninja warrior obstacle courses. Achieve real results with one of the best gyms in Dallas. Whether your aim is weight loss, muscle gain, or enhanced athletic performance, we are committed to providing the highest quality training and support. We stand behind our services with a 100% money-back guarantee. Join the ranks of those who've witnessed the Strong Fitness difference and transform yourself today!",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-6e76-71da-a46b-b0d28ed15344.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-6e76-71da-a46b-b0d28ed15344",
        "storage_key": "property/5652651228266496/019d01a0-6e76-71da-a46b-b0d28ed15344.webp",
        "width": 1000,
        "height": 828
      },
      "poi_business_url": "https://www.yelp.com/biz/strong-fitness-performance-and-ninja-farmers-branch-3?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.93142533711004,-96.838232",
      "poi_item_slug": "strong-fitness-performance-and-ninja-farmers-branch-3",
      "poi_latitude": "32.93142533711004",
      "poi_longitude": "-96.838232",
      "poi_miles_from_property": "4.38",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+19723734062",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ03NlhysnTIYR2p1STmF1kTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ff56716b-a1a3-4e65-b2a3-9410d53092c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Orangetheory Fitness Las Colinas",
      "poi_type": "Gyms",
      "poi_address": "7600 N MacArthur Blvd, Ste 140, Irving, TX 75063",
      "poi_short_description": "",
      "poi_long_description": "Orangetheory Fitness in Irving, TX offers heart rate zone training that delivers a smarter way to work out. Experience an expertly designed, full-body group workout combining cardio and strength training with real-time tracking for measurable results you can see and feel. Here in Irving, your heart rate sets the pace, enabling our triple-certified coaches to get you into the optimal zone. The result is a personalized fitness experience tailored to your fitness level.",
      "poi_featured_image": "https://s3-media1.fl.yelpcdn.com/bphoto/tg-JjJ7LJuH5UCsnh8a0TQ/o.jpg",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/orangetheory-fitness-las-colinas-irving?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.90964004540055,-96.95755874332036",
      "poi_item_slug": "orangetheory-fitness-las-colinas-irving",
      "poi_latitude": "32.90964004540055",
      "poi_longitude": "-96.95755874332036",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+19724740404",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJD-RovEkoTIYRtSFnX6qVSAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_03f0c370-3198-4d45-9e96-56a665104644",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "BURN Dallas",
      "poi_type": "Gyms",
      "poi_address": "11661 Preston Rd, Ste 175, Dallas, TX 75230",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-71e5-775b-bc99-364ba63cff12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-71e5-775b-bc99-364ba63cff12",
        "storage_key": "property/5652651228266496/019d01a0-71e5-775b-bc99-364ba63cff12.webp",
        "width": 562,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/burn-dallas-dallas?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.907346,-96.806414",
      "poi_item_slug": "burn-dallas-dallas",
      "poi_latitude": "32.907346",
      "poi_longitude": "-96.806414",
      "poi_miles_from_property": "6.16",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+12146136154",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJUT8hBpEgTIYRzCZ9yHo_Tko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_30cdcf6b-4b23-4615-98db-e8d0cff6c39f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Mary Immaculate Catholic School",
      "poi_type": "Elementary Schools",
      "poi_address": "14032 Dennis Ln, Farmers Branch, TX 75234",
      "poi_short_description": "",
      "poi_long_description": "For 60+ years, Mary Immaculate has helped students come to know and love the Person of Jesus Christ as they strive for college and heaven. Today, under the guidance of the Nashville Dominicans, that tradition is strengthened with a Catechesis of the Good Shepherd Atrium and academically challenging curriculum. We operate within the Diocese of Dallas and serve PreK4-8th grade. Our student body is diverse economically, geographically and ethnically. To immerse your child in the truth, beauty and goodness of a Catholic education, visit our website or call 972-243-7105 to schedule a tour.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-728c-7088-92a6-6289ee6d3334.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-728c-7088-92a6-6289ee6d3334",
        "storage_key": "property/5652651228266496/019d01a0-728c-7088-92a6-6289ee6d3334.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.yelp.com/biz/mary-immaculate-catholic-school-farmers-branch?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.936676,-96.884507",
      "poi_item_slug": "mary-immaculate-catholic-school-farmers-branch",
      "poi_latitude": "32.936676",
      "poi_longitude": "-96.884507",
      "poi_miles_from_property": "2.07",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+19722437105",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJa7ZQclMmTIYRyPgymqfQeYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4f40859e-98d1-404d-8b41-957bbacf93fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "The Sloan School",
      "poi_type": "Elementary Schools",
      "poi_address": "3131 N O Connor Rd, Irving, TX 75062",
      "poi_short_description": "",
      "poi_long_description": "Rated top Christian Based Pre-School and Private School in Irving, Texas The Sloan School, an exceptional private Christian school located in Irving, Texas, offers outstanding Preschool, Private Elementary School, After School and Summer programs for children 2 years old through 5th grade, as well as child care for children as young as 6 weeks old.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-7250-75f9-83c4-184313e0cc85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-7250-75f9-83c4-184313e0cc85",
        "storage_key": "property/5652651228266496/019d01a0-7250-75f9-83c4-184313e0cc85.webp",
        "width": 432,
        "height": 268
      },
      "poi_business_url": "https://www.yelp.com/biz/the-sloan-school-irving?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.848222,-96.95133",
      "poi_item_slug": "the-sloan-school-irving",
      "poi_latitude": "32.848222",
      "poi_longitude": "-96.95133",
      "poi_miles_from_property": "5.31",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+19726591199",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ3fxE7OSCToYRBFu8YbaWtzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8d8fca20-1a0a-4113-a25a-629689556ae2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Westwood School",
      "poi_type": "High Schools",
      "poi_address": "14340 Proton Rd, Dallas, TX 75244",
      "poi_short_description": "",
      "poi_long_description": "In 1986, The Westwood School was founded to address a real need for change in education by developing character, fostering community, and promoting academic excellence. For almost 40 years, The Westwood School has continued to grow offering Montessori education starting at 12 months old. Westwood blends the highly regarded method with the International Baccalaureate Diploma Programme, an ideal overlay to the foundation laid by the Montessori method. IB World Schools share a common philosophy–a commitment to high quality, challenging, international education that The Westwood School believes is important for our students.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/westwood-school-dallas?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.944362455572914,-96.83586773862304",
      "poi_item_slug": "westwood-school-dallas",
      "poi_latitude": "32.94436245557291",
      "poi_longitude": "-96.83586773862304",
      "poi_miles_from_property": "4.78",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+19722398598",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJx_HLpdMmTIYRX9IlRrvr2cA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_291d50ae-62ba-4ec3-b10b-99e1b3aff82e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Ranchview High School",
      "poi_type": "High Schools",
      "poi_address": "8401 Valley Ranch Pkwy E, Irving, TX 75063",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-767a-70fd-8da3-baeb967e8804.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-767a-70fd-8da3-baeb967e8804",
        "storage_key": "property/5652651228266496/019d01a0-767a-70fd-8da3-baeb967e8804.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/ranchview-high-school-irving?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.9187573727082,-96.9457058976288",
      "poi_item_slug": "ranchview-high-school-irving",
      "poi_latitude": "32.9187573727082",
      "poi_longitude": "-96.9457058976288",
      "poi_miles_from_property": "1.96",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+19729685000",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJee5-TkMoTIYRJ5Y2blXfjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7e98d6d4-0029-4c81-aacf-f2290b0fa1b6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Carrollton-Farmers Branch Independent School District",
      "poi_type": "High Schools",
      "poi_address": "1330 Valwood Pkwy, Carrollton, TX 75006",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-7289-714c-a4a7-229fa56591c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-7289-714c-a4a7-229fa56591c4",
        "storage_key": "property/5652651228266496/019d01a0-7289-714c-a4a7-229fa56591c4.webp",
        "width": 700,
        "height": 525
      },
      "poi_business_url": "https://www.yelp.com/biz/carrollton-farmers-branch-independent-school-district-carrollton-15?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.9392949,-96.9140553",
      "poi_item_slug": "carrollton-farmers-branch-independent-school-district-carrollton-15",
      "poi_latitude": "32.9392949",
      "poi_longitude": "-96.9140553",
      "poi_miles_from_property": "1.59",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+19729685660",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bf9a07aa-93a6-4c73-bc8f-2384550b4fe6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Jesuit College Preparatory School",
      "poi_type": "High Schools",
      "poi_address": "12345 Inwood Rd, Dallas, TX 75244",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-7763-723d-882f-65ea95876bff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-7763-723d-882f-65ea95876bff",
        "storage_key": "property/5652651228266496/019d01a0-7763-723d-882f-65ea95876bff.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/jesuit-college-preparatory-school-dallas?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.9184049658025,-96.8196192682129",
      "poi_item_slug": "jesuit-college-preparatory-school-dallas",
      "poi_latitude": "32.9184049658025",
      "poi_longitude": "-96.8196192682129",
      "poi_miles_from_property": "5.35",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+19723878700",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJQ7101cAgTIYR7v0N4_mzS5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_971c98cc-eeca-4461-bede-4f92523b5cea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Greenhill School",
      "poi_type": "High Schools",
      "poi_address": "4141 Spring Valley Rd, Addison, TX 75001",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-7760-7530-b607-1b0509db1a17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-7760-7530-b607-1b0509db1a17",
        "storage_key": "property/5652651228266496/019d01a0-7760-7530-b607-1b0509db1a17.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "https://www.yelp.com/biz/greenhill-school-addison-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.94187004216446,-96.8437413",
      "poi_item_slug": "greenhill-school-addison-2",
      "poi_latitude": "32.94187004216446",
      "poi_longitude": "-96.8437413",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+19726285400",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJTd7AktMmTIYR779yOyqGqNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_caee19e2-fd92-4140-bfd7-b86d80d4d7c9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Oak Crest Private School",
      "poi_type": "Private Schools",
      "poi_address": "1200 E Jackson Rd, Bldg 2, Carrollton, TX 75006",
      "poi_short_description": "",
      "poi_long_description": "Private school in Carrollton, Texas offering pre-K(3) through eighth grade. Voted best private school and best early childhood center. Small, friendly classes guide children through a challenging curriculum that focuses on 100% mastery of materials being learned. Emphasis is placed on the ability to apply what is being learned rather than on memorizing for a test. Oak Crest Private School offers summer camp, preschool through 8th grade, academics, Spanish, athletics, arts, student council, clubs & activities, and student travel. Contact our administration office to find out more about how Oak Crest Private School could help your child excel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-778d-723d-bdf5-a5e59d2d5246.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-778d-723d-bdf5-a5e59d2d5246",
        "storage_key": "property/5652651228266496/019d01a0-778d-723d-bdf5-a5e59d2d5246.webp",
        "width": 1000,
        "height": 563
      },
      "poi_business_url": "https://www.yelp.com/biz/oak-crest-private-school-carrollton?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.97455224,-96.90307442",
      "poi_item_slug": "oak-crest-private-school-carrollton",
      "poi_latitude": "32.97455224",
      "poi_longitude": "-96.90307442",
      "poi_miles_from_property": "3.98",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+12144835400",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJV_nDsAsmTIYRX-j8_HUwQyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0eb1d93e-f6a4-4492-8d3e-890be797b744",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Bronco Western Wear",
      "poi_type": "Shopping",
      "poi_address": "11538 Harry Hines Blvd, Ste A3, Dallas, TX 75229",
      "poi_short_description": "",
      "poi_long_description": "Huge variety of cowboy boots, cowgirl boots, western boots, belts and wallets in ostrich, crocodile, alligator, caiman, elephant and more. Best prices guaranteed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-7b8d-7798-a87f-9f8cf2f14e66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-7b8d-7798-a87f-9f8cf2f14e66",
        "storage_key": "property/5652651228266496/019d01a0-7b8d-7798-a87f-9f8cf2f14e66.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/bronco-western-wear-dallas?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.9034415,-96.893031",
      "poi_item_slug": "bronco-western-wear-dallas",
      "poi_latitude": "32.9034415",
      "poi_longitude": "-96.893031",
      "poi_miles_from_property": "1.46",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+19724844004",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJl3LEI44nTIYRwQ2aKbgcH3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_51f2548f-afe3-4658-8417-f23bd3897426",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Josey Records",
      "poi_type": "Shopping",
      "poi_address": "2821 Lyndon B Johnson Fwy, Ste 100, Dallas, TX 75234",
      "poi_short_description": "",
      "poi_long_description": "Store with new and used VINYL records + CDs, Tapes, DVDs, turntables, posters, special orders as well as live music and DJs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-7bce-7676-b9ca-57de78022398.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-7bce-7676-b9ca-57de78022398",
        "storage_key": "property/5652651228266496/019d01a0-7bce-7676-b9ca-57de78022398.webp",
        "width": 666,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/josey-records-dallas?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.91138,-96.8846",
      "poi_item_slug": "josey-records-dallas",
      "poi_latitude": "32.91138",
      "poi_longitude": "-96.8846",
      "poi_miles_from_property": "1.64",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+19722432039",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJi27AopgnTIYRp_MpmhEjb8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_707e9010-cf35-476a-a854-148c6348dac9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Blooms Candy & Soda Pop Shop",
      "poi_type": "Shopping",
      "poi_address": "1106 W Main St, Carrollton, TX 75006",
      "poi_short_description": "",
      "poi_long_description": "We are a kooky nostalgic/retro candy shop with hundreds of your favorite old school candies as well as hundreds and hundreds of glass bottled sodas and novelty gifts. Take a step back in time and enjoy the pop-culture antiques and memorabilia while you browse candies and sodas from the past and present. From a 5 lb gummy bear to over 80 flavors of salt water taffy, you're bound to find something to make you smile and reminisce the sweet treats of your youth.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-7bce-7676-b9ca-5b0333d32f0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-7bce-7676-b9ca-5b0333d32f0d",
        "storage_key": "property/5652651228266496/019d01a0-7bce-7676-b9ca-5b0333d32f0d.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/blooms-candy-and-soda-pop-shop-carrollton?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.9523935,-96.9083604",
      "poi_item_slug": "blooms-candy-and-soda-pop-shop-carrollton",
      "poi_latitude": "32.9523935",
      "poi_longitude": "-96.9083604",
      "poi_miles_from_property": "2.42",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+19724165230",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJxThi4zwmTIYRCkTNm9oewtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3adb99b2-7fdb-44f5-a4cd-5e512795a547",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Cell Phone Repair TX",
      "poi_type": "Shopping",
      "poi_address": "11422 Harry Hines Blvd, Ste 203, Dallas, TX 75229",
      "poi_short_description": "",
      "poi_long_description": "Cell Phone Repair TX is locally owned and operated. Established in 2009, we offer repairs in-house same day and most repairs are completed within 1 hour from drop off time. We can fix your mobile device and bring it back to life in-store while you wait! To get your free repair diagnostics please visit our corporate headquarters located in Shopper's Alley shopping center in suite #203. Need a phone that works with your existing plan? Offering a vast array of phones and tablets that can be purchased outright with no contract! Cell Phone Repair TX *In Shopper's Alley *Strip Center* Suite #203 11422 Harry Hines Blvd #203 Dallas, TX 75229 (214) 223-2304.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-7b88-764a-ade0-6ed2f4f13098.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-7b88-764a-ade0-6ed2f4f13098",
        "storage_key": "property/5652651228266496/019d01a0-7b88-764a-ade0-6ed2f4f13098.webp",
        "width": 600,
        "height": 450
      },
      "poi_business_url": "https://www.yelp.com/biz/cell-phone-repair-tx-dallas-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.897403296223075,-96.8904627811112",
      "poi_item_slug": "cell-phone-repair-tx-dallas-2",
      "poi_latitude": "32.89740329622308",
      "poi_longitude": "-96.8904627811112",
      "poi_miles_from_property": "1.86",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+12142232304",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJp6dLCo8nTIYRH4_ctRl-Dfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cfcfa8be-ee9b-4071-bef6-f9558d3441ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Nature's Gallery",
      "poi_type": "Shopping",
      "poi_address": "1102 S Elm St, Carrollton, TX 75006",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-7f5c-727e-b059-9b70f4026c88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-7f5c-727e-b059-9b70f4026c88",
        "storage_key": "property/5652651228266496/019d01a0-7f5c-727e-b059-9b70f4026c88.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/natures-gallery-carrollton?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.9519386291504,-96.9086456298828",
      "poi_item_slug": "natures-gallery-carrollton",
      "poi_latitude": "32.9519386291504",
      "poi_longitude": "-96.9086456298828",
      "poi_miles_from_property": "2.39",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+19724461994",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJB0vz6DwmTIYRxNqgePNOWp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a0b50ef1-b497-4e5a-9864-4432c220d5a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Locals Lounge",
      "poi_type": "Entertainment",
      "poi_address": "13050 Bee St, Ste 120, Farmers Branch, TX 75234",
      "poi_short_description": "",
      "poi_long_description": "A unique imbibing experience in Farmers Branch. Think global, drink local.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-7f5c-727e-b059-94c854c609f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-7f5c-727e-b059-94c854c609f8",
        "storage_key": "property/5652651228266496/019d01a0-7f5c-727e-b059-94c854c609f8.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.yelp.com/biz/locals-lounge-farmers-branch?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.92322,-96.89542",
      "poi_item_slug": "locals-lounge-farmers-branch",
      "poi_latitude": "32.92322",
      "poi_longitude": "-96.89542",
      "poi_miles_from_property": "1.03",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+14697707957",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJi11Bh8wnTIYR4q7VmJGzpTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_23d20e99-045a-45ff-9d67-4a633f2999d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "The Rose Gardens of Farmers Branch",
      "poi_type": "Entertainment",
      "poi_address": "2610 Valley View Ln, Farmers Branch, TX 75234",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-7f8a-75d8-b96e-4676d185d55b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-7f8a-75d8-b96e-4676d185d55b",
        "storage_key": "property/5652651228266496/019d01a0-7f8a-75d8-b96e-4676d185d55b.webp",
        "width": 562,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/the-rose-gardens-of-farmers-branch-farmers-branch?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.9233035,-96.8903912711639",
      "poi_item_slug": "the-rose-gardens-of-farmers-branch-farmers-branch",
      "poi_latitude": "32.9233035",
      "poi_longitude": "-96.8903912711639",
      "poi_miles_from_property": "1.31",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+19729192625",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJKxnsQ7onTIYReRFQsxO2wfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e9401387-1486-430b-81d0-547047f01ea7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "ICR Discovery Center",
      "poi_type": "Entertainment",
      "poi_address": "1830 Royal Ln, Dallas, TX 75229",
      "poi_short_description": "",
      "poi_long_description": "The ICR Discovery Center showcases how science confirms the accuracy of the Bible. Planetarium, interactive exhibits, theaters, live presentations, Discovery Store, and educational events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-7fdb-767a-b89b-bfe83e0e32a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-7fdb-767a-b89b-bfe83e0e32a7",
        "storage_key": "property/5652651228266496/019d01a0-7fdb-767a-b89b-bfe83e0e32a7.webp",
        "width": 1000,
        "height": 731
      },
      "poi_business_url": "https://www.yelp.com/biz/icr-discovery-center-dallas-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.895232,-96.917823",
      "poi_item_slug": "icr-discovery-center-dallas-2",
      "poi_latitude": "32.895232",
      "poi_longitude": "-96.917823",
      "poi_miles_from_property": "1.58",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+18007436374",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJSaPKWU4nTIYRnbHZsGS0S-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_efa50d6f-513f-48a4-8169-a102304baa6c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "poi_name": "Texas Card House",
      "poi_type": "Entertainment",
      "poi_address": "11834 Harry Hines Blvd, Ste 135, Dallas, TX 75234",
      "poi_short_description": "",
      "poi_long_description": "The fourth (and best?) Texas Card House location. Situated in North Dallas at the Sam Moon shopping center. We offer the nicest, most comfortable place to hang out with friends, have a beer (BYOB) and of course, play poker (on 26 tables).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-834a-715a-a85f-a0c641b0da4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a0-834a-715a-a85f-a0c641b0da4b",
        "storage_key": "property/5652651228266496/019d01a0-834a-715a-a85f-a0c641b0da4b.webp",
        "width": 748,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/texas-card-house-dallas?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=32.910684,-96.894614",
      "poi_item_slug": "texas-card-house-dallas",
      "poi_latitude": "32.910684",
      "poi_longitude": "-96.894614",
      "poi_miles_from_property": "1.14",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+14695219269",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJofxjkiAnTIYR_MtoKy2cfMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_01769bb664ce51526ccbeb75",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5d9062861f82bd8304b377a2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a51ed7491e5dd3b9c677941b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_54e6ec2467b7be6033fa75af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "day": "THU",
      "open_time": "10:30",
      "close_time": "18:00"
    },
    {
      "id": "ec_10e85e5c9caa97db775857d8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_52cf16a6901c139e8676fc77",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_26fede506f12de1a6f1c9a99",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "rating": "5",
      "name": "Alexa Bell",
      "text": "Living at The Crosby at Brickyard has been an incredible experience from day one. The property is beautiful, well-maintained, and thoughtfully designed, but what truly makes this community exceptional is the people, especially Christina.\n\nFrom the moment I toured the property, Christina went above and beyond. She is warm, welcoming, and unbelievably knowledgeable. She made the entire move-in process seamless, answered every question with patience, and continues to be one of the most genuine, helpful leasing professionals I’ve ever met. You can tell she truly cares about the residents and takes pride in making The Crosby feel like home.\n\nThe amenities are top-tier, the location is perfect, and the atmosphere is peaceful and upscale—but the customer service, especially from Christina, is what sets this place apart. If you’re looking for a community that values its residents and has staff who genuinely go out of their way for you, this is it.\n\nI couldn’t recommend The Crosby at Brickyard more. Thank you, Christina, for making this such a wonderful place to live!",
      "date": "2025-12-05",
      "title": "false"
    },
    {
      "id": "ec_caefcc5e091e56b409781376",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "rating": "5",
      "name": "Keely Clark",
      "text": "I’ve been living at the Crosby for about 3 years now and absolutely love it. Maintenance is fast and the complex is small so the amenities are always open and clean. Everyone who lives here is also very friendly and kind. Plus the location is perfect and very safe and has multiple walking trails nearby. Christina is absolutely amazing and always goes above and beyond for the residents.",
      "date": "2026-01-16",
      "title": "false"
    },
    {
      "id": "ec_a6957aeec76c0a9c0a97dcdd",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "rating": "5",
      "name": "Blaise Matheny",
      "text": "My experience at The Crosby at Brickyard has been nothing short of amazing. The community is clean, modern, and extremely well taken care of, but what truly sets it apart is the outstanding team that runs it, especially Christina.\n\nFrom the very beginning, Christina made everything feel effortless. She is incredibly friendly, professional, and attentive, and she always makes sure residents feel supported and informed. Whether it’s answering questions, giving helpful guidance, or simply offering a warm smile, she consistently goes the extra mile. Her dedication and genuine care make a huge difference in the overall living experience.\n\nThe amenities are beautiful, the location is convenient, and the environment is welcoming but the amazing service from Christina is what makes The Crosby stand out above the rest.\n\nIf you’re searching for a place that feels like home and has a team that truly values its residents, this is the one!",
      "date": "2025-12-05",
      "title": "false"
    },
    {
      "id": "ec_7a23a9aab896b1d397e2103a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "rating": "5",
      "name": "Seung Kang",
      "text": "Since I moved here six months ago, my life seems to have become richer and more fulfilling. Whenever I meet Marlene who cleans this place so diligently every day, she always greets me with a smile. I am truly grateful for the kindness and hard work of all the staff. I am happy that I can spend each day joyfully in this quiet and clean place.",
      "date": "2025-11-24",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_6f1d4816-024f-4c4c-924c-7ab48c05be8a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "Virtual Tour",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019e026c-9d72-702d-8699-2962045f1534.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e026c-9d72-702d-8699-2962045f1534",
        "storage_key": "property/5652651228266496/019e026c-9d72-702d-8699-2962045f1534.webp",
        "width": 640,
        "height": 640
      },
      "virtual_tour_title": "Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://kuula.co/share/collection/7lbtQ?fs=1&vr=1&initload=0&thumbs=1&info=0&logo=-1"
    },
    {
      "id": "custom_376b5610-d6eb-4b01-b479-dd1130626dca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019fd3a2-d47c-744f-a8d3-31540fb7b222.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-d47c-744f-a8d3-31540fb7b222",
        "storage_key": "property/5652651228266496/019fd3a2-d47c-744f-a8d3-31540fb7b222.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "A3.4 | 1x1 | 715 SqFt",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=s3Avr6t27rT"
    },
    {
      "id": "custom_a9bfba5f-c9f8-46c9-a0ae-ca8ebc94e0e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019fd3a2-d891-7488-8b4b-ea64e56569fe.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-d891-7488-8b4b-ea64e56569fe",
        "storage_key": "property/5652651228266496/019fd3a2-d891-7488-8b4b-ea64e56569fe.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "A4.1 | 1x1 | 744 SqFt",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=MTUHYsqKJoX"
    },
    {
      "id": "custom_6ec4558c-733b-4461-bc18-e2d0f1c106da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "B2.2 | 2x2 | 1116 SqFt",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://www.zillow.com/view-imx/af823024-02fb-476a-bf2c-ccd9d903b9a0?initialViewType=pano"
    },
    {
      "id": "custom_2fd8ecaa-7c54-4052-92f7-a549ad7664c0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019fd3a2-daf2-756b-b7f0-59b68347f447.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-daf2-756b-b7f0-59b68347f447",
        "storage_key": "property/5652651228266496/019fd3a2-daf2-756b-b7f0-59b68347f447.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "B5.1 | 2x2 | 1338 SqFt",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pabnHGP1hfF"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-5968-761a-925f-5ce590e2300d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-crosby-at-the-brickyard-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496"
    },
    {
      "lead_collector_id": "0198aa47-59cc-715b-8851-c919f6022dc6",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-crosby-at-the-brickyard-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496"
    },
    {
      "lead_collector_id": "0198aa47-5a2f-75c0-a928-c8fe07c4804b",
      "lead_source": "LANDING_PAGE",
      "name": "the-crosby-at-the-brickyard-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-farmers-branch-crosby",
      "search_query": "luxury apartments with pool Farmers Branch",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Farmers Branch",
      "h2_subtitle": "Discover luxury living with a pool at The Crosby at the Brickyard. Find upscale apartments in Farmers Branch with stunning amenities.",
      "page_copy": "The Crosby at the Brickyard Apartment Homes offers a superior lifestyle in Farmers Branch, TX, featuring luxury apartments with pool access and extensive facilities. Designed for those who seek style and comfort, our one and two-bedroom residences reflect the best in modern living. Boasting open concept kitchens adorned with granite countertops and hardwood floors, each apartment is a perfect blend of elegance and functionality.\n\nBeyond the stylish interiors, delight in our upscale amenities including a shimmering pool perfect for relaxing or socializing. Our pet-friendly community also provides scenic walking trails, Wi-Fi access, and 24-hour facilities access. Whether you're lounging by the pool or enjoying the tranquility of its surroundings, The Crosby at the Brickyard is where luxurious living reaches new heights.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Farmers Branch",
      "seo_description": "Explore luxury living at The Crosby in Farmers Branch, offering apartments with pool access and upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-farmers-branch-crosby",
      "search_query": "pet friendly apartments with dog park Farmers Branch TX",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments With Dog Park",
      "h2_subtitle": "Explore pet-friendly living at The Crosby with a dedicated dog park. Find perfect homes in Farmers Branch, TX for both you and your pets.",
      "page_copy": "Welcome to The Crosby at the Brickyard Apartment Homes, the premier pet-friendly apartments in Farmers Branch, TX. We understand that pets are family, which is why we offer a welcoming environment complete with a dedicated dog park, ensuring your furry friends have a space to play and explore.\n\nOur one and two-bedroom apartments are spacious and equipped with modern amenities, like air conditioning and hardwood flooring, making them comfortable for both you and your pets. Surrounded by scenic walking trails and offering Wi-Fi connectivity, The Crosby at the Brickyard is designed to cater to your every need—ensuring you and your pets enjoy a harmonious and fulfilling lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments With Dog Park",
      "seo_description": "Discover pet-friendly apartments in Farmers Branch with a dog park at The Crosby, offering ideal spaces for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "high-end-apartments-granite-countertops-75234-crosby",
      "search_query": "high-end apartments with granite countertops 75234",
      "category": "Amenity",
      "h1_title": "High-End Apartments with Granite Countertops",
      "h2_subtitle": "Discover high-end living with granite countertops in zip code 75234. Explore luxury options at The Crosby at the Brickyard.",
      "page_copy": "Discover the epitome of high-end living at The Crosby at the Brickyard Apartments, nestled in the heart of Farmers Branch, zip code 75234. Our one and two-bedroom residences are crafted with elegant features, such as stunning granite countertops that add a touch of sophistication to each open concept kitchen.\n\nBeyond the stylish interiors, The Crosby offers amenities designed to enhance your daily life. From secured Wi-Fi and framed mirrors to lush walking trails, every element is finely curated for a luxurious lifestyle. Located in a vibrant community with easy access to everything Farmers Branch has to offer, The Crosby remains the benchmark for elegance and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High-End Apartments with Granite Countertops",
      "seo_description": "Explore high-end apartments with granite countertops in 75234 at The Crosby, offering luxury living in Farmers Branch.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-farmers-branch-crosby",
      "search_query": "apartments with in unit laundry Farmers Branch",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry Nearby",
      "h2_subtitle": "Find apartments in Farmers Branch featuring the convenience of in-unit laundry. Discover life at The Crosby at the Brickyard.",
      "page_copy": "Experience the ultimate convenience at The Crosby at the Brickyard, where we offer modern apartments with in-unit laundry, right here in Farmers Branch. Our beautifully designed one and two-bedroom layouts provide not only the luxury of washing and drying laundry at home but also feature upscale finishes like granite countertops and hardwood floors.\n\nBeyond in-unit laundry facilities, enjoy an assortment of premium amenities tailored to enhance your lifestyle. Relax by our pool, take walks along scenic trails, and connect effortlessly with our Wi-Fi access. At The Crosby, every detail is planned to make your living experience seamless and enjoyable. Discover the quality and convenience that define our community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry Near You",
      "seo_description": "Discover The Crosby in Farmers Branch, offering apartments with in-unit laundry for optimal convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "modern-apartment-air-conditioning-near-dallas-crosby",
      "search_query": "modern apartment with air conditioning near Dallas",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Air Conditioning",
      "h2_subtitle": "Explore modern apartments with air conditioning near Dallas at The Crosby. Experience comfort and style minutes away from the city.",
      "page_copy": "Welcome to The Crosby at the Brickyard, where modern living meets ultimate comfort. Our apartments near Dallas not only feature contemporary designs but also include essential amenities like air conditioning, ensuring you stay cool and comfortable year-round.\n\nLocated just a short drive from downtown Dallas, our one and two-bedroom apartments offer stylish interiors with features such as granite countertops and hardwood floors. Whether you enjoy browsing scenic walking trails or need Wi-Fi access for work and leisure, The Crosby provides an inviting atmosphere that balances convenience with style, making it the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Air Conditioning",
      "seo_description": "Find modern apartments with air conditioning near Dallas at The Crosby, offering stylish living with comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-farmers-branch-tx-crosby",
      "search_query": "one bedroom apartments in Farmers Branch TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Farmers Branch",
      "h2_subtitle": "Explore one bedroom apartments in Farmers Branch, TX at The Crosby. Discover upscale living in a vibrant community.",
      "page_copy": "Discover the charm of one bedroom apartments at The Crosby at the Brickyard, located in the heart of Farmers Branch, TX. With thoughtfully designed spaces featuring granite countertops and hardwood floors, our apartments offer the perfect blend of comfort and style.\n\nEnjoy the unparalleled convenience of living near Dallas, where you can take advantage of expansive amenities like on-site Wi-Fi, air conditioning, and scenic walking trails. At The Crosby, we ensure that every resident experiences a luxurious lifestyle complemented by a welcoming community atmosphere. Make The Crosby your new home and experience the difference.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Farmers Branch",
      "seo_description": "Explore one bedroom apartments in Farmers Branch, TX at The Crosby, offering modern and convenient living with upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-75234-crosby",
      "search_query": "two bedroom apartments near 75234",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 75234",
      "h2_subtitle": "Discover spacious two bedroom apartments near the 75234 area at The Crosby. Enjoy a vibrant lifestyle with premium amenities.",
      "page_copy": "Welcome to The Crosby at the Brickyard, where our two bedroom apartments offer a perfect retreat near the 75234 area. Designed with modern conveniences like granite countertops and hardwood floors, our spacious layouts provide a comfortable living space for families or roommates.\n\nEnjoy easy access to downtown Dallas and relish in the community amenities including air conditioning, Wi-Fi connectivity, and scenic walking trails. The Crosby ensures a well-rounded living experience, blending convenience with a friendly atmosphere. Make life easier by choosing our elegant two bedroom options as your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 75234",
      "seo_description": "Find spacious two bedroom apartments near 75234 at The Crosby, featuring modern designs and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "apartments-near-brookhaven-college-crosby",
      "search_query": "apartments near Brookhaven College Farmers Branch",
      "category": "School",
      "h1_title": "Apartments Near Brookhaven College",
      "h2_subtitle": "Find ideal apartments near Brookhaven College in Farmers Branch. Enjoy modern living just minutes from campus at The Crosby.",
      "page_copy": "Experience convenience and style at The Crosby at the Brickyard, situated close to Brookhaven College in Farmers Branch. Our apartments are designed with students and professionals in mind, offering the perfect blend of modern amenities and proximity to campus.\n\nAt The Crosby, you'll enjoy open concept kitchens with granite countertops, spacious living areas with hardwood floors, and essential extras like air conditioning and Wi-Fi. Whether you're studying or unwinding, our community offers a supportive and comfortable environment, making it an ideal choice for those studying at Brookhaven College. Discover your new home ideally located for both education and leisure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Brookhaven College",
      "seo_description": "Explore The Crosby's modern apartments near Brookhaven College in Farmers Branch—ideal for students seeking comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "apartments-close-to-parker-university-tx-crosby",
      "search_query": "apartments close to Parker University TX",
      "category": "School",
      "h1_title": "Apartments Close to Parker University TX",
      "h2_subtitle": "Discover modern apartments close to Parker University, TX at The Crosby. Perfect for students seeking convenience and comfort.",
      "page_copy": "Located just a short drive from Parker University in Texas, The Crosby at the Brickyard offers exceptional living options perfect for students. Our community is designed with modern luxury in mind, featuring one and two-bedroom apartments equipped with upscale amenities, such as open concept kitchens and hardwood floors.\n\nEnjoy the benefits of living close to campus while taking advantage of community features like Wi-Fi and air conditioning. The serene walking trails offer a peaceful retreat after a long day of classes. Choose The Crosby and secure a stylish and convenient living environment tailored to meet your academic needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Parker University TX",
      "seo_description": "Explore apartments near Parker University, TX at The Crosby—stylish, modern, and convenient for students.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "rentals-near-north-lake-college-irving-crosby",
      "search_query": "rentals near North Lake College Irving",
      "category": "School",
      "h1_title": "Rentals Near North Lake College Irving",
      "h2_subtitle": "Explore convenient rentals near North Lake College Irving at The Crosby. Perfect for students desiring quality living.",
      "page_copy": "The Crosby at the Brickyard offers the ideal setting for those seeking rentals near North Lake College in Irving. Our thoughtfully designed one and two-bedroom apartments cater to students and professionals, providing a harmonious blend of convenience and modern living.\n\nTake advantage of our impressive amenities, including sleek granite countertops and elegant hardwood floors, all designed to enhance your living experience. Our community offers high-speed Wi-Fi, ensuring you're always connected, and beautiful scenic trails to unwind. Choose The Crosby and enjoy a premium lifestyle with easy access to North Lake College and the surrounding area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near North Lake College Irving",
      "seo_description": "Discover rentals close to North Lake College Irving at The Crosby—offering modern comforts and convenience for students.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "apartments-near-usahs-dallas-crosby",
      "search_query": "apartments near USAHS Dallas",
      "category": "School",
      "h1_title": "Apartments Near USAHS Dallas",
      "h2_subtitle": "Find great apartments near USAHS Dallas at The Crosby. Enjoy modern amenities just a short distance from campus.",
      "page_copy": "Located conveniently near the University of St. Augustine for Health Sciences (USAHS) in Dallas, The Crosby at the Brickyard offers students and professionals a perfect living environment. Our one and two-bedroom apartments come with modern amenities like granite countertops and hardwood floors, combining style with comfort.\n\nResidents of The Crosby enjoy excellent community features such as Wi-Fi and scenic walking trails, ideal for relaxation after a busy day. The proximity to USAHS Dallas ensures a quick commute, allowing students more time for study and leisure. Embrace an enriching lifestyle at The Crosby, where comfort meets convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near USAHS Dallas",
      "seo_description": "Explore modern living at The Crosby with apartments near USAHS Dallas, offering convenience for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "apartments-close-to-landry-elementary-school-crosby",
      "search_query": "apartments close to Landry Elementary School Farmers Branch",
      "category": "School",
      "h1_title": "Apartments Close to Landry Elementary School",
      "h2_subtitle": "Discover premium apartments close to Landry Elementary School in Farmers Branch. Ideal for families seeking comfort and convenience.",
      "page_copy": "Situated conveniently in Farmers Branch, The Crosby at the Brickyard provides spacious living options perfect for families with children attending Landry Elementary School. Our one and two-bedroom apartments are crafted with family-friendly features such as open concept kitchens and robust air conditioning for ultimate comfort.\n\nParents can take advantage of our pet-friendly environment and community amenities like Wi-Fi and scenic trails, making The Crosby a wonderful place to call home. With Landry Elementary School just a short distance away, you can enjoy a seamless school commute, providing more time for family activities and leisure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Landry Elementary School",
      "seo_description": "Find family-friendly living at The Crosby with apartments near Landry Elementary School in Farmers Branch.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "rent-near-field-middle-dallas-county-crosby",
      "search_query": "rent near Field Middle Dallas County",
      "category": "School",
      "h1_title": "Rent Near Field Middle Dallas County",
      "h2_subtitle": "Explore inviting rental options near Field Middle in Dallas County. Perfect for families and professionals alike.",
      "page_copy": "The Crosby at the Brickyard is ideal for those seeking rentals near Field Middle in Dallas County. Our community offers a variety of one and two-bedroom apartments designed to meet the needs of families and professionals, combining style and functionality.\n\nEnjoy modern living with amenities like air conditioning, framed mirrors, and high-speed Wi-Fi, making your day-to-day activities comfortable and efficient. With close proximity to Field Middle, commuting becomes a breeze, leaving you more time to enjoy the stunning walking trails and community offerings at The Crosby.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rent Near Field Middle Dallas County",
      "seo_description": "Discover ideal rentals at The Crosby, near Field Middle in Dallas County, featuring modern amenities and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "apartments-near-bush-middle-carrollton-crosby",
      "search_query": "apartments near Bush Middle Carrollton",
      "category": "School",
      "h1_title": "Apartments Near Bush Middle Carrollton",
      "h2_subtitle": "Find perfect apartments near Bush Middle in Carrollton. Convenient and comfortable living awaits you at The Crosby.",
      "page_copy": "The Crosby at the Brickyard offers an excellent choice for families seeking apartments near Bush Middle School in Carrollton. Our beautifully designed one and two-bedroom units ensure comfort and convenience, ideal for supporting a busy family lifestyle.\n\nOur community offers striking amenities, including hardwood floors and pet-friendly policies, as well as easy access to scenic walking trails. Located just a short drive from Bush Middle, The Crosby ensures stress-free commutes, allowing you more time to enjoy the surroundings and community features.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bush Middle Carrollton",
      "seo_description": "Experience living at The Crosby with beautiful apartments near Bush Middle School, perfect for families seeking convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "apartments-close-to-ranchview-high-school-irving",
      "search_query": "apartments close to Ranchview High School Irving",
      "category": "School",
      "h1_title": "Apartments Close to Ranchview High School",
      "h2_subtitle": "Discover stylish apartments close to Ranchview High School in Irving. Ideal for families and students seeking convenience.",
      "page_copy": "Located just a short drive from Ranchview High School in Irving, The Crosby at the Brickyard offers a perfect mix of comfort and accessibility. Our spacious one and two-bedroom apartments are crafted to fit the lifestyles of busy families and students.\n\nResidents enjoy upscale features such as granite countertops and ample Wi-Fi, blending modern convenience with cozy living. With Ranchview High School nearby, The Crosby provides an ideal living situation that allows easy school commutes and plenty of time to relax in our community's lush walking trails and well-maintained facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Ranchview High School",
      "seo_description": "Live near Ranchview High School at The Crosby, offering stylish apartments with modern amenities and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5652651228266496",
      "source": "generator",
      "page_item_url": "rentals-near-merit-academy-farmers-branch",
      "search_query": "rentals near Merit Academy Farmers Branch",
      "category": "School",
      "h1_title": "Rentals Near Merit Academy Farmers Branch",
      "h2_subtitle": "Discover spacious rentals near Merit Academy in Farmers Branch. Convenient and family-friendly living at The Crosby.",
      "page_copy": "Just steps away from Merit Academy, The Crosby at the Brickyard provides an ideal setting for those looking for rentals in Farmers Branch. Our one and two-bedroom apartments cater to both singles and families, ensuring a comfortable living experience.\n\nOur community features top-notch amenities such as air conditioning, hardwood floors, and high-speed Wi-Fi, which make everyday living a pleasure. With Merit Academy nearby, parents and students alike can enjoy effortless commutes, allowing more time to enjoy our pet-friendly environment and picturesque walking trails.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with granite island, stainless steel appliances, and dark wood cabinets.",
        "public_id": "019d01a0-5981-706a-bd05-38cdd437707b",
        "storage_key": "property/5652651228266496/019d01a0-5981-706a-bd05-38cdd437707b.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Merit Academy Farmers Branch",
      "seo_description": "Find perfect rentals at The Crosby, near Merit Academy in Farmers Branch, offering modern amenities and family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4758"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9147444440"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4692910875"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M8Z3FQJX"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 6"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "2b1c024e-89d4-48f9-a27c-7181caee1fdf"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/bd7e2d8c-1ca8-4c1a-8341-9848aac5a019/app.js?property=bd7e2d8c-1ca8-4c1a-8341-9848aac5a019&propertyName=The+Crosby+at+the+Brickyard+Apartment+Homes&channelUuid=c2491292-8dac-11ec-afb4-42010aa8d42b&buttonbgcolor=8f7a48\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im9QNkE5ZVBkRlNKVy9zY3RUUEU1YVE9PSIsInZhbHVlIjoiVzAwL0h6R09aOUpPNFAwRW9HeStpQT09IiwibWFjIjoiYTQyZjI4YjkxODEwYWIyODI3Y2YyYWRkMDJiYzFkNDFlYzRiNGI1NTgzYmI4MGJhZjcyYzRhYWJiYTUyMjA5ZCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "4758",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9147444440",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4692910875",
  "custom_google_gtm_id": "GTM-M8Z3FQJX",
  "custom_rollout_phase": "Phase 6",
  "custom_rentgrata_token": "2b1c024e-89d4-48f9-a27c-7181caee1fdf",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/bd7e2d8c-1ca8-4c1a-8341-9848aac5a019/app.js?property=bd7e2d8c-1ca8-4c1a-8341-9848aac5a019&propertyName=The+Crosby+at+the+Brickyard+Apartment+Homes&channelUuid=c2491292-8dac-11ec-afb4-42010aa8d42b&buttonbgcolor=8f7a48\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im9QNkE5ZVBkRlNKVy9zY3RUUEU1YVE9PSIsInZhbHVlIjoiVzAwL0h6R09aOUpPNFAwRW9HeStpQT09IiwibWFjIjoiYTQyZjI4YjkxODEwYWIyODI3Y2YyYWRkMDJiYzFkNDFlYzRiNGI1NTgzYmI4MGJhZjcyYzRhYWJiYTUyMjA5ZCJ9",
  "custom_audioeye_site_id": "6a4d2f04-3032-49c3-8451-36d8529406a2",
  "custom_audioeye_site_hash": "268aa52b9ff3df68e21427ba39f0cd17"
};

export const generatedAt = '2026-10-27T17:02:38.665Z';
